// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconListCheck, IconUserPlus, IconFileInfo, IconAlignCenter, IconBoxModel2, IconBoxModel, IconList } from '@tabler/icons';

// constant
const icons = {
    IconListCheck,
    IconUserPlus,
    IconFileInfo,
    IconAlignCenter,
    IconBoxModel2,
    IconBoxModel,
    IconList
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const accountantGroup = {
    id: 'accountant-group',
    type: 'group',
    children: [
        {
            id: 'accountant',
            title: <FormattedMessage id="accountant" />,
            type: 'collapse',
            breadcrumbs: false,
            icon: icons.IconAlignCenter,
            children: [
                {
                    id: 'accountant',
                    title: <FormattedMessage id="expense" />,
                    type: 'collapse',
                    breadcrumbs: false,
                    icon: icons.IconBoxModel,
                    children: [
                        {
                            id: 'approved-list',
                            title: <FormattedMessage id="approved-list" />,
                            type: 'item',
                            url: '/expense-list?type=approved',
                            breadcrumbs: false,
                            visible: true
                        },
                        {
                            id: 'my_new_approve_expenses_list',
                            title: <FormattedMessage id="my_new_approve_expenses_list" />,
                            type: 'item',
                            url: '/expense-list?type=my_new_approve_expenses',
                            breadcrumbs: false,
                            visible: true
                        },
                        {
                            id: 'accountant-list',
                            title: <FormattedMessage id="accountant-list" />,
                            type: 'item',
                            url: '/accounted-list',
                            breadcrumbs: false,
                            visible: true
                        },
                    ]
                },
                {
                    id: 'advance',
                    title: <FormattedMessage id="advance" />,
                    type: 'collapse',
                    breadcrumbs: false,
                    icon: icons.IconBoxModel2,
                    children: [
                        {
                            id: 'approved-list-advance',
                            title: <FormattedMessage id="approved-list-advance" />,
                            type: 'item',
                            url: '/advance-list?type=approved',
                            breadcrumbs: false,
                            visible: true
                        },
                        {
                            id: 'my_new_approve_advances_list',
                            title: <FormattedMessage id="my_new_approve_advances_list" />,
                            type: 'item',
                            url: '/advance-list?type=my_new_approve_advances',
                            breadcrumbs: false,
                            visible: true
                        },
                        {
                            id: 'advance-accountant-list',
                            title: <FormattedMessage id="advance-accountant-list" />,
                            type: 'item',
                            url: '/advance-accounted-list',
                            breadcrumbs: false,
                            visible: true
                        },
                        {
                            id: 'motivation-budget-list',
                            title: <FormattedMessage id="motivation-budget-list" />,
                            type: 'item',
                            url: '/motivation-budget-list',
                            breadcrumbs: false,
                            visible: true
                        }
                    ]
                },
            ]
        },
    ]
};

export default accountantGroup;
